import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import styles from "./DropdownButton.module.css";
import downArrow from "./Meeting Type.svg";

export function DropdownButton({
  options,
  placeholder = "Select an option",
  handlePick,
  selectedOption: initialSelected = null,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(initialSelected);
  const containerRef = useRef(null);
  const filteredOptions = options.filter(
    (option) => option.label !== selectedOption?.label
  );

  // Sync selectedOption with the prop if it changes
  useEffect(() => {
    if (initialSelected) {
      setSelectedOption(initialSelected);
    }
  }, [initialSelected]);

  //Closes dropdown if clicked outside of container
  useEffect(() => {
    const handleRefClose = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleRefClose);
    }

    return () => {
      document.removeEventListener("mousedown", handleRefClose);
    };
  }, [isOpen]);

  const handleSelect = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    handlePick(option.value);
  };

  return (
    <div
      ref={containerRef}
      className={`${styles.dropdown} ${isOpen ? styles.open : ""}`}
    >
      <div className={styles.dropdownToggle} onClick={() => setIsOpen(!isOpen)}>
        {selectedOption?.label || placeholder}
        <img
          src={downArrow}
          alt="dropdown arrow"
          className={`${styles.dropdownArrow} ${isOpen ? styles.open : ""}`}
        />
      </div>

      {isOpen && (
        <motion.div
          className={styles.dropdownMenu}
          initial={{ scaleY: 0.85, y: -6 }}
          animate={{ scaleY: 1, y: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          {filteredOptions.map((option) => (
            <div
              key={option.value}
              className={styles.dropdownItem}
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </div>
          ))}
        </motion.div>
      )}
    </div>
  );
}
